export default __webpack_public_path__ + "static/media/Hokky1.d4361cfd.png";